export const apiUseFetch = async (request, opts) => {
  const config = useRuntimeConfig();
  const {$propelAuth} = useNuxtApp();
  if (!$propelAuth) return false; // If the plugin isn't loaded, don't do anything (happens server side — which doesn't matter)
  const auth = await $propelAuth.getAuthenticationInfoOrNull();
  if (!auth) return false; // If the user isn't logged in, do nothing
  const {getActiveOrg} = await useActiveOrg();
  return useFetch(request, {
    baseURL: config.public.apiBaseUrl,
    headers: {
      Authorization: `Bearer ${auth.accessToken}`,
      'X-Vector-Org': getActiveOrg() || null,
    },
    ...opts,
  });
};
